import InductOverview from "../induct/InductOverview";
import InductArea from "../induct/InductArea";
import Container from "../induct/Container";
import Box from "@amzn/meridian/box";
import React from "react";
import ReceiveFilter from "../receive/ReceiveFilter";
import ReceiveOverView from "../receive/ReceiveOverView";
import ReceiveGroupBy from "../receive/ReceiveGroupBy";
import LineHauls from "../linehaul/LineHauls";
import CycleManagementTable from "../inductmanagementv2/CycleManagementTable";
import ForceInduct from "../inductmanagementv2/ForceInduct";
import DeliveryWindowConfigTable from "../inductmanagementv2/DeliveryWindowConfigTable";
import Column from "@amzn/meridian/column";
import LineHaulFilter from "../linehaul/LineHaulFilter";
import InductFilter from "../induct/InductFilter";
import InboundOverview from "../inbound/InboundOverview";
import InductConfigurations from "../inductmanagementv2/InductConfigurations";

export const DEFAULT_ROUTES = {
    "/induct": "/induct/induct_overview",
    "/receive": "/receive/receive_overview",
    "/inductManagement": "/inductManagement/managecycle",
    "/inbound": "/inbound/inbound_overview"
};

export const INDUCT_ROUTES = [{
    name: "induct-overview",
    path: "/induct/induct_overview",
    id:"receive.overall_status",
    component: () => {
        let inductFilter = <InductFilter/>;
        return (
           <Column>
               {inductFilter}
               <InductOverview/>
           </Column>
        )
    },
}, {
    name: "induct-area",
    path: "/induct/induct_area",
    id:"induct.induct_area",
    component: () => {
        return (<InductArea/>)
    },
}, {
    name: "container",
    path: "/induct/container",
    id:"induct.container",
    component: () => {
        return (
            <Column>
                <LineHaulFilter/>
                <Container/>
            </Column>
        )
    },
}];

export const RECEIVE_ROUTES = [{
    name: "receive-overview",
    path: "/receive/receive_overview",
    id:"receive.overall_status",
    component: () => {
        return(
            <Box>
                <ReceiveFilter/>
                <ReceiveOverView/>
            </Box>
        )
    },
}, {
    name: "linehauls",
    path: "/receive/linehauls",
    id: "linehaul.linehauls",
    component: (props) => {
        return (
            <Box>
                <ReceiveGroupBy/>
                <LineHauls history={props.history}/>
            </Box>
        )
    },
}];

export const INDUCT_MANAGEMENT_INDUCT_CONFIGURATION_ROUTE = {
    name: "induct-configuration",
    path: "/inductManagement/induct-configuration",
    id:"inductmanagement.inductconfiguration",
    component: () => {
        return (<InductConfigurations/>)
    },
};

export const INDUCT_MANAGEMENT_ROUTES = [{
    name: "induct-management",
    path: "/inductManagement/managecycle",
    id:"inductmanagement.manage_cycle",
    component: () => {
        return (<CycleManagementTable/>)
    },
}, {
    name: "force-induct",
    path: "/inductManagement/forceinduct",
    id:"inductmanagement.force_induct",
    component: () => {
        return (<ForceInduct/>)
    },
},
    {
    name: "delivery-window-configuration",
    path: "/inductManagement/deliverywindow",
    id:"inductmanagement.deliveryWindowConfiguration",
    component: () => {
        return (<DeliveryWindowConfigTable/>)
    },
},
    INDUCT_MANAGEMENT_INDUCT_CONFIGURATION_ROUTE
];

export const INDUCT_MANAGEMENT_MANAGE_CYCLE_ROUTE = {
    name: "induct-management",
    path: "/inductManagement/managecycle",
    id:"inductmanagement.manage_cycle",
    component: () => {
        return (<CycleManagementTable/>)
    },
};

export const INDUCT_MANAGEMENT_FORCE_INDUCT_ROUTE = {
    name: "force-induct",
    path: "/inductManagement/forceinduct",
    id:"inductmanagement.force_induct",
    component: () => {
        return (<ForceInduct/>)
    },
};

export const INDUCT_MANAGEMENT_DELIVERY_WINDOW_ROUTE =    {
        name: "delivery-window-configuration",
        path: "/inductManagement/deliverywindow",
        id:"inductmanagement.deliveryWindowConfiguration",
        component: () => {
            return (<DeliveryWindowConfigTable/>)
        },
};

export const INBOUND_ROUTES = [{
    name: "inbound-overview",
    path: "/inbound/inbound_overview",
    id:"inbound.overview",
    component: () => {
        return (<InboundOverview/>)
    },
}];


// WEBPACK FOOTER //
// ./src/components/util/RouteConstants.js